import '@vfde-brix/notification/dist/styles.css';
import { createNotificationComponent } from '@vfde-brix/notification';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-notification', createNotificationComponent, NO_PATTERN_BUSINESS_LOGIC);
